import React from "react";
import GroupBranchTableComponent from "./groupBranchTable.component";

function GroupBranchTableContainer({ rows, lang }) {
  return <GroupBranchTableComponent rows={rows} lang={lang} />;
}

export default GroupBranchTableContainer;
